import { useEffect, useState } from "react";
import { auth, db } from "../../../config/firebaseConfig";
import { doc, getDoc, setDoc, serverTimestamp, updateDoc, arrayUnion } from "firebase/firestore";
import ProfileFormComponent, { ProfileFormState } from "../../../components/ProfileFormComponent";
import  { ProfileForm } from "../../../components/profile/ProfileFields";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useNavigate, useParams } from "react-router-dom";
import { useToast } from "../../../util/ToastProvider";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";
export default function EditProfilePage() {
  const [formData, setFormData] = useState<ProfileForm | null>(null);
  const [addRelated, setAddRelated]= useState<boolean>(false)
  const [relatedId, setRelatedId]= useState<string | null>(null)
  const [snapData, setSnapData] = useState<any>()
  const [userId, setUserId] = useState<string | null>(null)
  const [loading, setLoading] = useState(false);
  
 
  const navigate = useNavigate();
  const toast = useToast();
  const { id} = useParams<{ id: string }>();
  const app = getApp();
  const functions = getFunctions(app);
  const manageProfile = httpsCallable(functions, "manageProfile");
  useEffect(() => {
    console.log("uid", id)
    if (!id || id == 'new') {
      console.log("one")
      setUserId(null)
      console.warn("No id in store yet – skipping fetch.");
      setAddRelated(true)
      return;
    }else if( /^[A-Za-z0-9_-]+--[A-Za-z0-9_-]+$/.test(id)){
      console.log("two")
      setRelatedId(id.split("--")[1])
      fetchUserDocOnce(id.split("--")[0], id.split("--")[1]);
      setAddRelated(true)
      setUserId(id.split("--")[0])
    }else{
      console.log("three")  
      fetchUserDocOnce(id, null);
      setUserId(id)
    }
    
  }, [id]);

  async function fetchUserDocOnce(uid: string, relatedIdValue: string| null) {
    try {
      const ref = doc(db, "users", uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const userData = snap.data()
        let profileData;
        console.log("relatedId", relatedIdValue)
        if(relatedIdValue){
          console.log("profileData---->", userData.profile )
          const relatedPersonData =
          userData?.profile?.relatedPersons &&
          Object.entries(userData.profile.relatedPersons).find(
            ([, value]: [string, any]) => value.id === relatedIdValue
          );
          if(relatedPersonData){
            const [relatedPersonKey, relatedPersonValue] = relatedPersonData;
            setSnapData(relatedPersonValue)
            profileData = {profile: relatedPersonValue}
          }else{
            toast.error("Error");
            navigate("/user/profile");
          }
        }else{
          setSnapData(userData)
          profileData = userData
        }
        
        const { form, dobDisplay } = buildProfileFormFromFS(profileData);
        
        setFormData(form)
      } else {
        console.log("⚠️ No /users doc for uid:", uid);
      }
    } catch (err) {
      console.error("❌ Failed to fetch /users doc:", err);
    }
  }
  function buildProfileFormFromFS(docData: any | null | undefined): {
    form: ProfileForm;
    dobDisplay: string | null;
  } {
    const p = docData?.profile ?? {};
    const birth = p?.birth ?? {};
    const curr = p?.current ?? {};
    const id = p?.identity ?? {};
    const legal = p?.legalHistory ?? {};
    const traits = p?.traits ?? {};
  
    const fullName =
      (id.fullName && id.fullName.trim()) ||
      [id.givenName, id.middleNames, id.familyName].filter((x) => (x ?? "").trim()).join(" ") ||
      null;
  
    const hadOtherLegalNames: "yes" | "no" | null =
      typeof legal.hadOtherLegalNames === "boolean"
        ? (legal.hadOtherLegalNames ? "yes" : "no")
        : null;
  
    const prev = Array.isArray(legal.previousNames) ? legal.previousNames : [];
    const previousNames = prev
      .map((n:any) => ({
        name: (n?.name ?? "") || null,
        from: n?.from ?? null,
        to: n?.to ?? null,
        type: n?.type ?? null
      }))
      .filter((n:any) => (n.name ?? "").trim().length > 0);
  
    const dobDisplay = formatDOB(birth.date ?? null, birth.time ?? null);
  
    const form: ProfileForm = {
      fullName,
      nicknames: id.nicknames ?? null,
      pronoun: id.pronoun ?? null,
      hadOtherLegalNames,
      previousNames,
      birth: {
        date: birth?.date,
        time: birth?.time,
        place: birth?.place,
      },
      dominantHand: traits.dominantHand ?? null,
      placeOfBirth: birth.place ?? null,
      currentResidence: curr.residence ?? null,
      spiritualOrientation: traits.spiritualOrientation ?? null,
      relation:traits.relationship
    };
    console.log("form")
    console.log("form",form)
    return { form, dobDisplay };
  }
 function formatDOB(date?: string | null, time?: string | null): string | null {
    if (!date && !time) return null;
    if (date && time) {
      // Treat as local time (e.g., Asia/Kolkata). If parsing fails, join raw.
      const iso = `${date}T${time}`;
      const d = new Date(iso);
      return isNaN(d.getTime())
        ? `${date}, ${time}`
        : d.toLocaleString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
          });
    }
    return date ?? time ?? null;
  }

  const handleSave = async (form: any) => {
    if (!auth.currentUser) return;
    console.log("id", id)
    console.log("formData",form)

    
    // new realted person add-profile
    if(addRelated && ! relatedId){
      try{
        await manageProfile({
          action: "addRelatedPerson",
          data: form,
        });
        toast.success("Related Person added successfully ✅");
        navigate("/user/profile");
      }catch(error:any){
        toast.error(error.message || "Error adding new person ❌");
        navigate("/user/profile");
      }
      
    }
    // edit related person
    else if(addRelated && relatedId){
      try{
        console.log("Data-----------> ", form)
        console.log("Id-----------> ", relatedId)
        await manageProfile({
          action: "editRelatedPerson",
          data: form,
          relatedPersonId: relatedId
        });
        toast.success("Related Person Updated successfully ✅");
        navigate("/user/profile");
      }catch(error:any){
        toast.error(error.message || "Error Updating new person ❌");
        navigate("/user/profile");
      }
    } // edit profile
    else{
      // if (!userId ){
      //   throw new Error("Missing UID for profile update")
      // }
      // const userRef = doc(db, "users", userId);
      // const existingRelatedPersons = snapData?.profile?.relatedPersons || [];

      // const mergedProfile = {
      //   ...snapData.profile,
      //   ...form,
      //   relatedPersons: existingRelatedPersons, 
      //   updatedAt: serverTimestamp(), // set top-level updatedAt
      // };
      // const payload = {
      //   ...snapData, // keep everything outside profile as-is
      //   profile: mergedProfile, // safely merged profile
      //   profileEditVersion: (snapData.profileEditVersion || 0) + 1, // increment
      // };
      // if (payload.profileEditVersion >= 3) {
      //   toast.error("You’ve reached the maximum number of profile edits allowed ❌");
      //   navigate("/user/profile");
      //   return;
      // }
      // try {
       
      //   console.log("payload", payload)
      //   await setDoc(userRef, payload);
      //   toast.success("Profile updated successfully ✅");
      //   console.log("✅ Profile updated successfully");
      //   navigate("/user/profile");

      // } catch (error:any) {
      //   console.error("❌ Error updating profile:", error);
      //   toast.error(error.message || "Error updating profile ❌");
      //   // navigate("/user/profile");
      // }

      if (!userId) {
        toast.error("Missing UID for profile update ❌");
        return;
      }
  
      setLoading(true);
  
      try {
        // 1️⃣ Get existing profile snapshot (for merge)
        const userRef = doc(db, "users", userId);
        const snap = await getDoc(userRef);
  
        if (!snap.exists()) {
          toast.error("User profile not found ❌");
          setLoading(false);
          return;
        }
  
        const snapData = snap.data();
        const existingRelatedPersons = snapData?.profile?.relatedPersons || [];
  
        // 2️⃣ Merge local form data safely
        const mergedProfile = {
          ...snapData.profile,
          ...form,
          relatedPersons: existingRelatedPersons,
        };
  
        // 3️⃣ Prepare Cloud Function payload
        const manageProfile = httpsCallable(functions, "manageProfile");
  
        // 4️⃣ Call backend function (which enforces version limit & rules)
        const result: any = await manageProfile({
          action: "editProfile",
          data: mergedProfile,
        });
  
        // 5️⃣ Handle success
        if (result.data?.success) {
          toast.success(result.data.message || "Profile updated successfully ✅");
          console.log("✅ Profile updated successfully");
          navigate("/user/profile");
        } else {
          toast.error("Unexpected error while updating profile ❌");
        }
      } catch (error: any) {
        console.error("❌ Error updating profile:", error);
        toast.error(error.message || "Error updating profile ❌");
      } finally {
        setLoading(false);
      }
    }
    
  };
  if (id !== "new" && formData === null) {
    return <div className="p-4 text-center">Loading…</div>;
  }

  return (
    <ProfileFormComponent
      isRelated={addRelated}
      initialData={formData}
      onSave={handleSave}
    />
  );
}
